import { Component, OnInit, Input, forwardRef } from '@angular/core';
import {
  ControlValueAccessor,
  FormGroupDirective,
  NgForm,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { FormGroup, FormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/internal/operators';

@Component({
  selector: 'app-autocomplete',
  templateUrl: './autocomplete.component.html',
  styleUrls: ['./autocomplete.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AutocompleteComponent),
      multi: true,
    },
  ],
})
export class AutocompleteComponent implements OnInit {
  @Input() notRequiredObject: any = false;
  @Input() label: string = '';
  _isInvalid: any;
  @Input() get isInvalid(): any {
    return this._isInvalid;
  }
  set isInvalid(value: any) {
    this._isInvalid = value;
    if (value) {
      this.control.setErrors({ invalid: value });
    }
  }

  _options: any = [];
  @Input() get options(): any {
    return this._options;
  }
  set options(value: any) {
    this._options = value;
  }

  @Input() appearance: any = 'legacy';
  @Input() validText: any = '';
  @Input() atributeDisplay: string = 'name';

  counter: number = 0;
  control = new FormControl();
  isDisabled: boolean = false;
  public filteredOptions: any;

  // Dont touch
  onChange = (_: any) => {};
  onTouch = () => {};

  constructor() {
    this.filteredOptions = this.control.valueChanges.pipe(
      startWith(''),
      map((value) => {
        this.onTouch();
        this.onChange(value);
        if (typeof value !== 'object') {
          if (!this.notRequiredObject || (this.notRequiredObject && !value)) {
            this.control.setErrors({ invalid: value });
          }
          return this._filter(value);
        }
      })
    );
  }

  ngOnInit(): void {}
  onInput(event: any) {
    let value = event.target.value;
    // if (typeof data === 'string') {
    //   return this._filter(data);
    // } else if (typeof data === 'object') {
    //   this.onChange(data);
    // }
    // this.counter = event.target.value.length;
    // this.value = event.target.value;
    // this.onTouch();
    // this.onChange(this.value);
  }

  get displayText() {
    return (value: any) => (value ? value[this.atributeDisplay] : '');
  }

  _filter(value: any) {
    if (typeof value === 'object') {
      return [];
    }
    const filterValue = value?.toLowerCase();
    return this.options.filter((option: any) =>
      option[this.atributeDisplay].toLowerCase().includes(filterValue)
    );
  }

  showPanel() {
    if (!this.control.value) {
      this.control.setValue('');
    }
  }

  /**
   * ====================== ControlValueAccessor Interface functions ======================
   */

  /**
   * Trae el valor puesto en un ngModel, ReactiveForm, etc. Ese valor podemos pasárselo a nuestro input nativo.
   * @param value
   */
  writeValue(value: any): void {
    setTimeout(() => {
      this.control.patchValue(value);
    }, 100);
  }

  /**
   * Registramos una función que luego usamos para informarle a Angular cuál es el valor de nuestro Form Control.
   * registerOnChange(fn: any): void {}
   * @param fn
   */
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  /**
   * Registramos una función que luego ejecutaremos cuando necesitemos que nuestro Form Control tenga el estodo “touched”.
   * @param fn
   */
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  /**
   * Trae el estado disabled desde nuestro Reactive Form. Podemos usar este estado para pasarselo a nuesto input nativo.
   * @param isDisabled
   */
  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }
}
